import { render, staticRenderFns } from "./ReportePantalla.vue?vue&type=template&id=8a6ad082&"
import script from "./ReportePantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a6ad082', component.options)
    } else {
      api.reload('8a6ad082', component.options)
    }
    module.hot.accept("./ReportePantalla.vue?vue&type=template&id=8a6ad082&", function () {
      api.rerender('8a6ad082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/Reporte/ReportePantalla.vue"
export default component.exports